<template>
  <div>
    <v-layout v-for="i in value.length" :key="i">
      <v-flex>
        <!-- NOTE: i starts at 1, not 0 -->
        <v-text-field
          :label="`${capitalize(label)} ${i} Full Name`"
          :rules="[atLeastOne]"
          :value="value[i - 1]"
          data-cy="people"
          @input="change(i - 1, $event);"
        />
      </v-flex>
      <v-flex v-if="i - 1" xs2>
        <v-btn @click="value.splice(i - 1, 1);"> Remove {{ label }} {{ i }} </v-btn>
      </v-flex>
    </v-layout>
    <v-btn @click="value.push('');"> Add {{ label }} </v-btn><br />
  </div>
</template>

<script>
import { capitalize } from 'lodash-es';

export default {
  filter: { capitalize },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  methods: {
    capitalize,
    atLeastOne() {
      return this.value.some(v => !!v) || `Must have at least one ${capitalize(this.label)}`;
    },
    change(index, event) {
      const people = Array.from(this.value);
      people[index] = event;
      this.$emit('input', people);
    },
  },
};
</script>
